<template>
  <div>
    <div
      v-for="(gripDomainCategory, index) in gripDomainCategories"
      :key="index"
      :class="['flex', 'flex-row', 'list-item', 'mb1']"
    >
      <div class="flex cell flex-column">
        <b :class="$style.name">
          {{ gripDomainCategory.name }}
        </b>
      </div>
      <div>
        <a @click="handleEdit(gripDomainCategory)" :class="$style.editBtn">
          <b-icon icon="pencil" size="is-small" />
        </a>
        <a
          @click="handleDelete(gripDomainCategory.id)"
          :class="$style.deletebtn"
        >
          <b-icon icon="delete" size="is-small" />
        </a>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import { GripDomainCategory } from '../../../store/types/grip.types';
import DeleteDomainCategoryForm from './DeleteDomainCategoryForm.vue';
import DomainCategoryModal from './DomainCategoryModal.vue';

@Component({
  components: { DomainCategoryModal, DeleteDomainCategoryForm },
})
export default class DomainCategoryList extends Vue {
  @Prop() public gripDomainCategories!: GripDomainCategory[];

  @Action('projects/getGripDomainCategories')
  public getGripDomainCategories!: (projectId: number) => void;

  get projectId(): number {
    return +this.$route.params.projectId;
  }

  public handleEdit(gripDomainCategory: GripDomainCategory): void {
    this.$buefy.modal.open({
      parent: this,
      props: {
        projectId: this.projectId,
        gripDomainCategoryDetails: gripDomainCategory,
        modalTitle: 'Edit',
      },
      component: DomainCategoryModal,
      hasModalCard: true,
    });
  }

  public handleDelete(gripDomainCategoryId: number): void {
    this.$buefy.modal.open({
      parent: this,
      props: {
        projectId: this.projectId,
        gripDomainCategoryId,
        gripDomainCategories: this.gripDomainCategories,
      },
      events: {
        close: () => {
          this.$emit('close');
        },
      },
      component: DeleteDomainCategoryForm,
      hasModalCard: true,
    });
  }
}
</script>
<style lang="scss" module>
.editBtn {
  color: #21b5ea;
  padding-right: 12px;
}
.deletebtn {
  color: #21b5ea;
}

.name {
  font-size: 14px;
  font-weight: 700;
  line-height: 17px;
  color: #444f51;
  max-width: 70ch;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.pagination nav {
  border-right: none !important;
}

.pagination nav ul {
  max-width: none !important;
}

.pagination nav li a,
.settingTabs nav li a:hover {
  height: auto !important;
  width: auto !important;
  font-size: inherit !important;
  line-height: inherit !important;
  font-size: 1em !important;
  margin: 0.25rem !important;
  padding-left: 0.5em !important;
  padding-right: 0.5em !important;
  text-align: center !important;
  justify-content: center !important;
}
</style>
